export default __webpack_public_path__ + "static/media/deleted_acct.10600c59.svg";